/* Chosen To Go theme JS */
(function () {
  'use strict';

  var CTG = window.CTG || { routes: { root: '/', cartAdd: '/cart/add.js', cart: '/cart' }, strings: {} };
  var S = CTG.strings || {};

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function readJSON(el) {
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }

  /* ---------- cart ---------- */
  var toastTimer;
  function formatMoney(cents) {
    var fmt = CTG.moneyFormat || '${{amount}}';
    var amount = (Math.max(cents, 0) / 100).toFixed(2);
    var whole = String(Math.round(Math.max(cents, 0) / 100));
    return fmt.replace(/\{\{\s*amount_no_decimals\s*\}\}/, whole).replace(/\{\{\s*amount\s*\}\}/, amount);
  }
  function shippingBar(total) {
    var fs = CTG.freeShipping || {};
    if (!fs.enabled || !fs.popup || !fs.goal) return null;
    var left = fs.goal - total;
    var pct = left > 0 ? Math.floor(total * 100 / fs.goal) : 100;
    var wrap = document.createElement('div');
    wrap.className = 'ctg-ship' + (left > 0 ? '' : ' is-done');
    var p = document.createElement('p');
    p.className = 'ctg-ship__text';
    p.textContent = left > 0 ? String(fs.message || '').split('[amount]').join(formatMoney(left)) : (fs.success || '');
    var track = document.createElement('div');
    track.className = 'ctg-ship__track';
    track.setAttribute('role', 'progressbar');
    track.setAttribute('aria-label', S.shipProgress || 'Progress to free shipping');
    track.setAttribute('aria-valuemin', '0');
    track.setAttribute('aria-valuemax', '100');
    track.setAttribute('aria-valuenow', String(pct));
    var fill = document.createElement('div');
    fill.className = 'ctg-ship__fill';
    fill.style.width = pct + '%';
    track.appendChild(fill);
    wrap.appendChild(p);
    wrap.appendChild(track);
    return wrap;
  }
  function hideToast() {
    var t = $('[data-ctg-toast]');
    if (t) t.hidden = true;
  }
  function toast(content, total) {
    var t = $('[data-ctg-toast]');
    if (!t) return;
    t.textContent = '';
    var row = document.createElement('div');
    row.className = 'ctg-toast__row';
    var msg = document.createElement('span');
    if (typeof content === 'string') {
      msg.textContent = content;
    } else {
      msg.textContent = (S.added || 'Added to your bag') + ' ';
      var a = document.createElement('a');
      a.href = CTG.routes.cart;
      a.textContent = S.viewBag || 'View bag';
      msg.appendChild(a);
    }
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ctg-toast__close';
    close.setAttribute('aria-label', S.close || 'Close');
    close.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6 6 18"/></svg>';
    close.addEventListener('click', hideToast);
    row.appendChild(msg);
    row.appendChild(close);
    t.appendChild(row);
    if (typeof total === 'number') {
      var bar = shippingBar(total);
      if (bar) t.appendChild(bar);
    }
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(hideToast, 6000);
  }
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') hideToast();
  });
  function updateTopBar(cart) {
    var fs = CTG.freeShipping || {};
    var bar = $('[data-ship-top]');
    if (!bar || !fs.enabled || !fs.top || !fs.goal) return;
    var total = cart.total_price;
    var left = fs.goal - total;
    var pct = left > 0 ? Math.floor(total * 100 / fs.goal) : 100;
    bar.hidden = !cart.item_count;
    bar.classList.toggle('is-done', left <= 0);
    var text = $('[data-ship-text]', bar);
    if (text) text.textContent = left > 0 ? String(fs.message || '').split('[amount]').join(formatMoney(left)) : (fs.success || '');
    var track = $('[data-ship-track]', bar);
    if (track) track.setAttribute('aria-valuenow', String(pct));
    var fill = $('[data-ship-fill]', bar);
    if (fill) fill.style.width = pct + '%';
  }
  function refreshCount() {
    return fetch(CTG.routes.root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
        updateTopBar(cart);
        return cart;
      });
  }
  function addToCart(variantId, qty) {
    return fetch(CTG.routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: qty || 1 }] })
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok) throw new Error(data.description || data.message || S.error || 'Error');
        return data;
      });
    }).then(function (data) {
      return refreshCount()
        .then(function (cart) { toast(null, cart.total_price) })
        .catch(function () { toast(null) })
        .then(function () { return data });
    });
  }

  function renderPrice(el, price, compare) {
    el.textContent = '';
    function part(tag, cls, label, text) {
      var n = document.createElement(tag);
      if (cls) n.className = cls;
      var h = document.createElement('span');
      h.className = 'ctg-visually-hidden';
      h.textContent = label;
      n.appendChild(h);
      n.appendChild(document.createTextNode(text));
      return n;
    }
    if (compare) {
      el.appendChild(part('s', 'ctg-compare', 'Regular price ', compare));
      el.appendChild(document.createTextNode(' '));
      el.appendChild(part('span', 'ctg-sale', 'Sale price ', price));
    } else {
      var s = document.createElement('span');
      s.textContent = price;
      el.appendChild(s);
    }
  }

  /* ---------- shared product picker ---------- */
  function Picker(root, opts) {
    this.root = root;
    this.opts = opts || {};
    this.product = null;
    this.color = null;
    this.size = null;
    this.ask = false;
    this.el = {
      image: $(opts.image, root),
      price: $(opts.price, root),
      swatches: $(opts.swatches, root),
      sizes: $(opts.sizes, root),
      colorName: $$(opts.colorName, root),
      add: $(opts.add, root),
      askBtn: $(opts.askBtn, root),
      bubbleAsk: $('[data-bubble-ask]', root),
      bubbleVerse: $('[data-bubble-verse]', root),
      bubbleAskText: $('[data-bubble-ask-text]', root),
      bubbleVerseText: $('[data-bubble-verse-text]', root)
    };
    var self = this;
    if (this.el.askBtn) {
      this.el.askBtn.addEventListener('click', function () {
        self.ask = !self.ask;
        self.renderAsk();
      });
    }
  }
  Picker.prototype.load = function (product, preset) {
    this.product = product;
    var first = null;
    var vs = product.variants || [];
    if (preset) {
      for (var i = 0; i < vs.length; i++) if (vs[i].id === preset) { first = vs[i]; break; }
    }
    if (!first) {
      for (var j = 0; j < vs.length; j++) if (vs[j].available) { first = vs[j]; break; }
    }
    first = first || vs[0] || {};
    this.color = first.color || (product.colors[0] && product.colors[0].name) || '';
    // prefer a common middle size for a nicer default
    var preferred = ['L', 'M'];
    this.size = first.size || '';
    if (!preset) {
      for (var k = 0; k < preferred.length; k++) {
        var v = this.find(this.color, preferred[k]);
        if (v && v.available) { this.size = preferred[k]; break; }
      }
    }
    this.ask = false;
    this.render();
  };
  Picker.prototype.find = function (color, size) {
    var vs = this.product.variants;
    for (var i = 0; i < vs.length; i++) {
      var v = vs[i];
      if ((v.color || '') === (color || '') && (v.size || '') === (size || '')) return v;
    }
    return null;
  };
  Picker.prototype.variant = function () {
    var v = this.find(this.color, this.size);
    if (!v) {
      // fall back to any available size in this color
      var vs = this.product.variants;
      for (var i = 0; i < vs.length; i++) if (vs[i].color === this.color && vs[i].available) { v = vs[i]; this.size = v.size; break; }
    }
    return v || this.product.variants[0];
  };
  Picker.prototype.colorObj = function () {
    var cs = this.product.colors || [];
    for (var i = 0; i < cs.length; i++) if (cs[i].name === this.color) return cs[i];
    return null;
  };
  Picker.prototype.render = function () {
    var self = this;
    var p = this.product;
    var v = this.variant();
    var c = this.colorObj();

    // image
    var src = (c && c.image) || p.image;
    if (this.el.image && src) {
      if (this.el.image.getAttribute('src') !== src) {
        var img = this.el.image;
        var clone = img.cloneNode(false);
        clone.src = src;
        clone.alt = p.title + (c ? ' — ' + c.name : '');
        clone.hidden = false;
        img.parentNode.replaceChild(clone, img);
        this.el.image = clone;
      }
    }
    if (this.el.price && v) renderPrice(this.el.price, v.price, v.compare);
    this.el.colorName.forEach(function (el) { el.textContent = self.color; });

    // swatches
    if (this.el.swatches) {
      this.el.swatches.innerHTML = '';
      (p.colors || []).forEach(function (col) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ctg-swatch';
        b.style.background = col.hex;
        b.setAttribute('aria-label', col.name);
        b.title = col.name;
        b.setAttribute('aria-pressed', col.name === self.color ? 'true' : 'false');
        var anyAvail = p.variants.some(function (x) { return x.color === col.name && x.available; });
        if (!anyAvail) b.disabled = true;
        b.addEventListener('click', function () { self.color = col.name; self.render(); });
        self.el.swatches.appendChild(b);
      });
      this.el.swatches.closest('.ctg-field').hidden = !(p.colors && p.colors.length);
    }

    // sizes
    if (this.el.sizes) {
      this.el.sizes.innerHTML = '';
      (p.sizes || []).forEach(function (s) {
        var b = document.createElement('button');
        b.type = 'button';
        b.className = 'ctg-pill';
        b.textContent = s;
        b.setAttribute('aria-pressed', s === self.size ? 'true' : 'false');
        var match = self.find(self.color, s);
        if (!match || !match.available) b.disabled = true;
        b.addEventListener('click', function () { self.size = s; self.render(); });
        self.el.sizes.appendChild(b);
      });
      this.el.sizes.closest('.ctg-field').hidden = !(p.sizes && p.sizes.length);
    }

    // add button
    if (this.el.add) {
      var avail = v && v.available;
      this.el.add.disabled = !avail;
      this.el.add.textContent = avail ? (S.addToBag || 'Add to bag') + (this.size ? ' · ' + this.size : '') : (S.soldOut || 'Sold out');
    }

    // ask
    if (this.el.askBtn) this.el.askBtn.hidden = !(p.ask && p.verse);
    this.renderAsk();

    if (this.opts.onChange) this.opts.onChange(v, this);
  };
  Picker.prototype.renderAsk = function () {
    var p = this.product;
    var on = this.ask && p.ask && p.verse;
    if (this.el.askBtn) {
      this.el.askBtn.setAttribute('aria-pressed', on ? 'true' : 'false');
      this.el.askBtn.textContent = on ? 'Hide the conversation' : 'What will they ask?';
    }
    if (this.el.bubbleAsk) {
      this.el.bubbleAsk.hidden = !on;
      this.el.bubbleVerse.hidden = !on;
      if (on) {
        this.el.bubbleAskText.textContent = '“' + p.ask + '”';
        this.el.bubbleVerseText.textContent = p.verse;
      }
    }
  };

  /* ---------- homepage stage ---------- */
  var currentStage = null;

  function initStage(scope) {
    var stage = $('[data-ctg-stage]', scope);
    if (!stage || stage.getAttribute('data-ready')) return null;
    stage.setAttribute('data-ready', '1');
    var list = readJSON($('[data-stage-json]', stage)) || [];
    if (!list.length) return null;
    var idx = 0;
    var vibeEl = $('[data-stage-vibe]', stage);
    var defaultLabel = vibeEl ? vibeEl.textContent : '';
    var counter = $('[data-stage-counter]', stage);
    var link = $('[data-stage-link]', stage);

    var picker = new Picker(stage, {
      image: '[data-stage-image]', price: '[data-stage-price]', swatches: '[data-stage-swatches]',
      sizes: '[data-stage-sizes]', colorName: '[data-stage-colorname]', add: '[data-stage-add]', askBtn: '[data-stage-ask]'
    });

    function show(i) {
      idx = (i + list.length) % list.length;
      var p = list[idx];
      picker.load(p);
      if (counter) counter.textContent = pad(idx + 1) + ' / ' + pad(list.length);
      if (vibeEl) vibeEl.textContent = p.vibe || defaultLabel;
      if (link) { link.textContent = p.title; link.href = p.url; }
      $$('[data-card]').forEach(function (card) {
        card.classList.toggle('is-active', card.getAttribute('data-handle') === p.handle);
      });
    }

    $('[data-stage-prev]', stage).addEventListener('click', function () { show(idx - 1); });
    $('[data-stage-next]', stage).addEventListener('click', function () { show(idx + 1); });

    // swipe on touch
    var startX = null;
    var view = $('.ctg-stage__view', stage);
    view.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    view.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) show(idx + (dx < 0 ? 1 : -1));
      startX = null;
    });

    var addBtn = $('[data-stage-add]', stage);
    addBtn.addEventListener('click', function () {
      var v = picker.variant();
      if (!v) return;
      addBtn.disabled = true;
      addToCart(v.id, 1).catch(function (err) { toast(err.message); })
        .then(function () { picker.render(); });
    });

    show(0);

    currentStage = {
      loadByHandle: function (handle, fallback) {
        for (var i = 0; i < list.length; i++) if (list[i].handle === handle) { show(i); return true; }
        if (fallback) { list.push(fallback); show(list.length - 1); return true; }
        return false;
      },
      el: stage
    };
    return currentStage;
  }

  /* ---------- vibe grid ---------- */
  function initGrids(scope) {
    $$('[data-ctg-grid]', scope).forEach(function (grid) {
      if (grid.getAttribute('data-ready')) return;
      grid.setAttribute('data-ready', '1');
      var data = readJSON($('[data-grid-json]', grid)) || [];
      var byHandle = {};
      data.forEach(function (p) { byHandle[p.handle] = p; });

      var chips = $$('[data-chip]', grid);
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var v = chip.getAttribute('data-chip');
          chips.forEach(function (c) { c.setAttribute('aria-pressed', c === chip ? 'true' : 'false'); });
          $$('[data-card]', grid).forEach(function (card) {
            card.hidden = !!v && card.getAttribute('data-vibe') !== v;
          });
        });
      });

      $$('[data-card]', grid).forEach(function (card) {
          card.addEventListener('click', function (e) {
            var stageApi = currentStage && document.body.contains(currentStage.el) ? currentStage : null;
            if (!stageApi) return;
            if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
            var h = card.getAttribute('data-handle');
            if (stageApi.loadByHandle(h, byHandle[h])) {
              e.preventDefault();
              stageApi.el.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'center' });
            }
          });
        });
    });
  }

  /* ---------- product page ---------- */
  function initProduct(scope) {
    var root = $('[data-ctg-product]', scope);
    if (!root || root.getAttribute('data-ready')) return;
    root.setAttribute('data-ready', '1');
    var product = readJSON($('[data-product-json]', root));
    if (!product) return;
    var input = $('[data-variant-id]', root);
    var form = $('[data-product-form]', root);

    var picker = new Picker(root, {
      image: '[data-product-image]', price: '[data-product-price]', swatches: '[data-swatches]',
      sizes: '[data-sizes]', colorName: '[data-color-name]', add: '[data-add]', askBtn: '[data-ask-toggle]',
      onChange: function (v) {
        if (!v) return;
        if (input) input.value = v.id;
        if (window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }
    });
    var preset = parseInt(new URL(window.location.href).searchParams.get('variant'), 10) || (input && parseInt(input.value, 10));
    picker.load(product, preset);

    $$('[data-thumb]', root).forEach(function (t) {
      t.addEventListener('click', function () {
        var img = $('[data-product-image]', root);
        if (img) img.src = t.getAttribute('data-thumb');
      });
    });

    if (form) {
      form.addEventListener('submit', function (e) {
        var v = picker.variant();
        if (!v || !window.fetch) return;
        e.preventDefault();
        var btn = $('[data-add]', root);
        btn.disabled = true;
        addToCart(v.id, 1).catch(function (err) { toast(err.message); })
          .then(function () { picker.render(); });
      });
    }
  }

  function safe(fn, scope) {
    try { fn(scope); } catch (err) { if (window.console) console.error('[Chosen To Go]', err); }
  }
  function init(scope) {
    scope = scope || document;
    safe(initStage, scope);
    safe(initGrids, scope);
    safe(initProduct, scope);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);

  // Theme editor: sections are redrawn when a setting changes, so set them up again.
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
